import React from 'react'
import styled from '@emotion/styled'

import {Icon} from '@vio/atlas/Icon'
import {NoStyleButton} from '@vio/atlas/src/components/designSystem/helpers/NoStyleButton'
import {Text} from '@vio/atlas/src/components/designSystem/Text'
import {cssTheme} from '@vio/atlas/src/themes'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'

import {SelectedElement} from '../../../utils/selectedElement'

const Wrapper = styled(NoStyleButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${cssTheme.layout.spacing.s200};
  background-color: ${cssTheme.colors.background.brand.tertiary};
  padding: ${cssTheme.layout.spacing.s400};
  border-top: 1px solid;
  border-color: ${cssTheme.colors.border.brand.tertiary};
  width: 100%;
`

// Added as a part of c747927f-deal-freeze-srp.
interface Props {
  onClick: (e: React.MouseEvent) => void
}
export const HotelCardDealFreezeBanner: React.FC<Props> = ({onClick}) => {
  return (
    <Wrapper onClick={onClick} data-id={SelectedElement.DealFreezeBanner}>
      <Icon size="sm" name="Ice" colorPath="content.interactive.primary" />
      <Text variant="labelS" colorPath="content.interactive.primary">
        <FormattedMessageWrapper
          id="dealFreeze.freezeADeal"
          defaultMessage="Freeze a deal while you decide"
        />
      </Text>
      <Icon
        size="sm"
        name="ChevronRight"
        colorPath="content.interactive.primary"
      />
    </Wrapper>
  )
}
